import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Document = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.375 8.3125V6.78125C11.375 6.2591 11.1676 5.75835 10.7984 5.38913C10.4292 5.01992 9.92839 4.8125 9.40625 4.8125H8.53125C8.3572 4.8125 8.19028 4.74336 8.06721 4.62029C7.94414 4.49722 7.875 4.3303 7.875 4.15625V3.28125C7.875 2.7591 7.66758 2.25835 7.29837 1.88913C6.92915 1.51992 6.42839 1.3125 5.90625 1.3125H4.8125M4.8125 8.75H9.1875M4.8125 10.5H7M6.125 1.3125H3.28125C2.919 1.3125 2.625 1.6065 2.625 1.96875V12.0312C2.625 12.3935 2.919 12.6875 3.28125 12.6875H10.7187C11.081 12.6875 11.375 12.3935 11.375 12.0312V6.5625C11.375 5.17011 10.8219 3.83476 9.83731 2.85019C8.85274 1.86562 7.51739 1.3125 6.125 1.3125Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 14 14" strokeWidth={0.9}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Document };